import {createSlice} from "@reduxjs/toolkit";
import * as actions from "./actions";
import {IFavoriteDeleteItem, ISelectedPrecisions, ITOHistory} from "../types";
import {
  DELETED_MARKETS_KEY,
  FAVORITES_MARKETS_KEY,
  FEE_FILTER_KEY,
  FILTER_PERCENT_KEY,
  HIDDEN_EXCHANGES_KEY,
  HIDE_NUM_FILTER_KEY,
  HIGHLIGHT_FROM_KEY, LANG_KEY
} from "../constants";

export interface InitState {
  is_stop_by_to_details: boolean,
  feeFilter?: number
  hideNumFilter?: number
  highlightFrom?: number
  filterPercent?: number
  hiddenExchanges: string[]
  isToDetailsOpen: boolean,
  isSettingsOpen: boolean,
  isFavoriteOpen: boolean,
  isMenuOpen: boolean,
  isPlay: boolean,
  isInfoOpen: boolean,
  selectedItem?: ITOHistory,
  selectedItemIndex?: number,
  currentToHistoryState: ITOHistory[],
  selectedPrecisions?: ISelectedPrecisions,
  favorites: IFavoriteDeleteItem[],
  deleted: IFavoriteDeleteItem[],
  lang: 'en' | 'ua',
  isLangOpen: boolean,
}

export const initialState: InitState = {
  is_stop_by_to_details: false,
  hideNumFilter: Number(JSON.parse(localStorage.getItem(HIDE_NUM_FILTER_KEY) || JSON.stringify(0))),
  highlightFrom: Number(JSON.parse(localStorage.getItem(HIGHLIGHT_FROM_KEY) || JSON.stringify(0))),
  feeFilter: Number(JSON.parse(localStorage.getItem(FEE_FILTER_KEY) || JSON.stringify(0))),
  filterPercent: Number(JSON.parse(localStorage.getItem(FILTER_PERCENT_KEY) || JSON.stringify(0))),
  hiddenExchanges: JSON.parse(localStorage.getItem(HIDDEN_EXCHANGES_KEY) || JSON.stringify([])),
  isToDetailsOpen: false,
  isFavoriteOpen: false,
  isSettingsOpen: false,
  isMenuOpen: false,
  isPlay: false,
  isInfoOpen: false,
  selectedItem: undefined,
  selectedItemIndex: undefined,
  currentToHistoryState: [],
  selectedPrecisions: undefined,
  favorites: JSON.parse(localStorage.getItem(FAVORITES_MARKETS_KEY) || JSON.stringify([])),
  deleted: JSON.parse(localStorage.getItem(DELETED_MARKETS_KEY) || JSON.stringify([])),
  lang: JSON.parse(localStorage.getItem(LANG_KEY) || JSON.stringify("ua")),
  isLangOpen: false,
}


export const flowReducer = createSlice({
  name: 'toFlowState',
  initialState,
  reducers: {},
  extraReducers: ({ addCase }) => {
    addCase(actions.setIsStoppedByToDetails, (state, {payload}) => {
      state.is_stop_by_to_details = payload
    })
    addCase(actions.setFeeFilter, (state, {payload}) => {
      state.feeFilter = payload
    })
    addCase(actions.setHideNumFilter, (state, {payload}) => {
      state.hideNumFilter = payload
    })
    addCase(actions.setHighlightFrom, (state, {payload}) => {
      state.highlightFrom = payload
    })
    addCase(actions.setHiddenExchanges, (state, {payload}) => {
      state.hiddenExchanges = payload
    })
    addCase(actions.setFilterPercent, (state, {payload}) => {
      state.filterPercent = payload
    })
    addCase(actions.setIsToDetailsOpen, (state, {payload}) => {
      state.isToDetailsOpen = payload
    })
    addCase(actions.setIsMenuOpen, (state, {payload}) => {
      state.isMenuOpen = payload
    })
    addCase(actions.setIsPlay, (state, {payload}) => {
      state.isPlay = payload
    })
    addCase(actions.setIsInfoOpen, (state, {payload}) => {
      state.isInfoOpen = payload
    })
    addCase(actions.setSelectedItem, (state, {payload}) => {
      state.selectedItem = payload
    })
    addCase(actions.setSelectedPrecisions, (state, {payload}) => {
      state.selectedPrecisions = payload
    })
    addCase(actions.setSelectedItemIndex, (state, {payload}) => {
      state.selectedItemIndex = payload
    })
    addCase(actions.setCurrentHistoryState, (state, {payload}) => {
      state.currentToHistoryState = payload
    })
    addCase(actions.setIsFavoriteOpen, (state, {payload}) => {
      state.isFavoriteOpen = payload
    })
    addCase(actions.setIsSettingsOpen, (state, {payload}) => {
      state.isSettingsOpen = payload
    })
    addCase(actions.setFavorites, (state, {payload}) => {
      state.favorites = payload
    })
    addCase(actions.setDeleted, (state, {payload}) => {
      state.deleted = payload
    })
    addCase(actions.setLang, (state, {payload}) => {
      state.lang = payload
    })
    addCase(actions.setIsLangOpen, (state, {payload}) => {
      state.isLangOpen = payload
    })
  },
}).reducer;